// extracted by mini-css-extract-plugin
export var container = "_d0-0";
export var icon = "_d0-1";
export var text = "_d0-2";